import { useEffect, useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import type { Bodega } from '@/types/bodega.model';

interface DeleteBodegaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (id: string | number) => Promise<void>;
  bodega?: Bodega;
}

const DeleteBodegaModal = ({ isOpen, onClose, onDelete, bodega }: DeleteBodegaModalProps) => {
  const [itemToDelete, setItemToDelete] = useState<Bodega | undefined>(undefined);

  // Populate form when bodega changes
  useEffect(() => {
    if (bodega) {
      setItemToDelete(bodega);
    } else {
      setItemToDelete(undefined);
    }
  }, [bodega]);

  const handleDelete = async () => {
    if (itemToDelete?.id) {
      await onDelete(itemToDelete.id);
      onClose();
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="top-center"
      backdrop="blur"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Eliminar Bodega</ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de que deseas eliminar la bodega <strong>{itemToDelete?.nombre}</strong>?</p>
              <p className="text-danger">Esta acción no se puede deshacer.</p>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="danger" 
                variant="light" 
                onPress={onClose}
              >
                Cancelar
              </Button>
              <Button 
                color="primary" 
                onPress={handleDelete}
              >
                Eliminar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DeleteBodegaModal;